export default function (state, val) {
    state.list.push({
        id: val.id,
        load: true,
        data: null,
        value: val.id,
        label: '',
        agreements: [],
        paymentOperation: null,
        contragentType: null,
        contragent: null,
        contragentName: '',
        legal: null,
        currency: null,
        legals: [],
        sum: 0,
        form: {
            RegularPaymentId: val.id,
            Name: '',
            NameLat: '',
            PaymentDirection: 1,
            PaymentOperationID: 0,
            RateArticleId: null,
            CategoryId: 0,
            PaymentTypeId: 0,
            CashId: 0,
            PaymentAccountId: 0,
            AccountNumber: '',
            ContragentType: 1,
            ContragentID: 0,
            ContragentName: 0,
            PartnerLegalEntityId: 0,
            PartnerLegalName: '',
            Sum: 0,
            CurrencyId: 0,
            RegularPaymentTypeId: 0,
            dayMonth: 1,
            dayWeek: 1,
            dayYear: '',
            dayOne: '',
            NotificationsEndDate: '',
            PaymentFor: '',
            Comment: '',
        },
    });
}